/**
 * @readonly
 * @enum {string}
 */
export const TournamentGameStatus = {
  UPCOMING: "upcoming",
  STARTED: "started"
}
